/* The hero remains still without JavaScript or when reduced motion is preferred. */
if (!customElements.get('dfc-bed-motion')) {
  customElements.define('dfc-bed-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.image = this.querySelector('img');
      this.button = this.querySelector('button');
      if (!this.image || !this.button || !this.dataset.playingSrc || !this.dataset.stillSrc) return;
      this.controller = new AbortController();
      this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this.controller.signal };
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.setPlaying(!this.playing), options);
      this.motionPreference.addEventListener('change', event => {
        if (event.matches) this.setPlaying(false);
      }, options);
      this.setPlaying(!this.motionPreference.matches);
    }
    setPlaying(playing) {
      this.playing = playing;
      this.image.src = playing ? this.dataset.playingSrc : this.dataset.stillSrc;
      this.button.textContent = playing ? 'Pause bed animation' : 'Play bed animation';
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

/* Native gallery scrolling remains available without JavaScript. */
if (!customElements.get('dfc-bed-gallery')) {
  customElements.define('dfc-bed-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.gallery-track');
      this.slides = [...this.querySelectorAll('.gallery-slide')];
      this.thumbnails = [...this.querySelectorAll('[data-index]')];
      if (!this.track || this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.querySelector('.gallery-controls').hidden = false;
      this.querySelector('.gallery-thumbnails').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1), options);
      this.thumbnails.forEach((button, i) => button.addEventListener('click', () => this.go(i), options));
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
        this.update();
      });
      this.resizeObserver.observe(this.track);
      this.update();
    }
    go(index) {
      const target = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      if (!this.track.clientWidth) return;
      const next = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.track.scrollLeft / this.track.clientWidth)));
      this.index = next;
      this.querySelector('.gallery-count').textContent = `${next + 1} / ${this.slides.length}`;
      this.thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === next)));
      const active = this.thumbnails[next];
      const strip = active.parentElement;
      const activeBox = active.getBoundingClientRect();
      const stripBox = strip.getBoundingClientRect();
      if (activeBox.left < stripBox.left || activeBox.right > stripBox.right) {
        strip.scrollLeft += activeBox.left - stripBox.left - (strip.clientWidth - active.clientWidth) / 2;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
